import { useState, useEffect, useMemo } from 'react';
import { isString } from '../utils/index.js';
import { useGetDataIndexColumns } from './useGetDataIndexColumns.js';
import { useMemoizedFn } from './useMemoizedFn.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function mergeColumns(src, target, mergeKey) {
  const res = src;
  if (Array.isArray(res) && Array.isArray(target)) {
    res.forEach((t, i) => {
      var _a, _b;
      if (t == null ? void 0 : t.children) {
        mergeColumns(t.children, (_a = target[i]) == null ? void 0 : _a.children, mergeKey);
      } else {
        res[i][mergeKey] = ((_b = target.find((x) => {
          const targetDataIndex = Array.isArray(x.dataIndex) ? x.dataIndex.join("-") : x.dataIndex;
          const resDataIndex = Array.isArray(res[i].dataIndex) ? res[i].dataIndex.join("-") : res[i].dataIndex;
          return targetDataIndex === resDataIndex;
        })) == null ? void 0 : _b[mergeKey]) || res[i][mergeKey];
        if (res[i][mergeKey] === void 0) {
          delete res[i][mergeKey];
        }
      }
    });
  }
  return res;
}
function useLocalColumns({
  columnsState,
  resizableColumns,
  columns
}) {
  const columnsProp = useGetDataIndexColumns(columns);
  const initLocalColumns = useMemoizedFn(() => {
    var _a;
    const { persistenceType, persistenceKey } = columnsState || {};
    if (!persistenceKey || !persistenceType) {
      return columnsProp;
    }
    if (typeof window === "undefined") return columnsProp;
    const storage = window[persistenceType];
    try {
      const localResizableColumns = (_a = JSON.parse((storage == null ? void 0 : storage.getItem(persistenceKey)) || "{}")) == null ? void 0 : _a.resizableColumns;
      return mergeColumns(columnsProp || [], localResizableColumns, "width");
    } catch (error) {
      console.error(error);
    }
  });
  const [localColumns, setLocalColumns] = useState(initLocalColumns);
  useEffect(() => {
    setLocalColumns(initLocalColumns());
  }, [columnsProp]);
  useEffect(() => {
    const { persistenceType, persistenceKey } = columnsState || {};
    if (!persistenceKey || !persistenceType || !(resizableColumns == null ? void 0 : resizableColumns.length)) {
      return;
    }
    if (typeof window === "undefined") return;
    const storage = window[persistenceType];
    try {
      storage.setItem(
        persistenceKey,
        JSON.stringify(__spreadProps(__spreadValues({}, JSON.parse((storage == null ? void 0 : storage.getItem(persistenceKey)) || "{}")), {
          resizableColumns: resizableColumns.map((col) => {
            const localCol = {
              dataIndex: col.dataIndex,
              key: col.key,
              width: col.width,
              children: col.children
            };
            if (isString(col.title)) {
              localCol.title = col.title;
            }
            return localCol;
          })
        }))
      );
    } catch (error) {
      console.error(error);
    }
  }, [resizableColumns]);
  const resetLocalColumns = useMemoizedFn((resetStorage = true) => {
    setLocalColumns([...(resetStorage ? columns : columnsProp) || []]);
  });
  return {
    localColumns: useMemo(() => localColumns, [localColumns]),
    resetLocalColumns
  };
}

export { useLocalColumns };
